<template>
    <b-container fluid class="mb-5">
        <b-row class="bgray-200 mb-5 py-4">
            <b-col cols="2">
                <b-button
                    variant="icon"
                    :to="{ name: 'TemplateList' }"
                    class="mb-2"
                    :disabled="is_loading_template"
                    small
                    >
                    &lang; <span class="pl-2">목록으로 이동</span>
                </b-button>
                <b-button
                    variant="icon"
                    :to="{ name: 'EditingTemplate', query: { value_new: false, template_id: $route.params.template_code } }"
                    :disabled="is_loading_template"
                    small
                    >
                    &lang; <span class="pl-2">편집 페이지로 이동</span>
                </b-button>
            </b-col>
            <b-col cols="6" offset-md="1" class="text-center">
                <div :class="['d-flex', 'flex-column justify-content-center align-items-center h-100']">
                    <div v-show="!is_loading_template">
                        <h3>{{ template_name }}</h3>
                        <h5 class="font-weight-normal ml-2 f-85">(type: {{ template_type }})</h5>
                    </div>
                    <b-spinner v-show="is_loading_template" style="width: 2.5rem; height: 2.5rem;" />
                </div>
                
            </b-col>
        </b-row>
        <b-row class="mb-3 mx-5">
            <b-col cols="12" md="6">
                <b-form-group label="번역상태 별 질문보기" label-class="h2" v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group
                        id="checkbox-group-view-translation-list"
                        v-model="conditionalView_selected"
                        :options="conditionalViewOption"
                        :aria-describedby="ariaDescribedby"
                        name="conditional-view-translation-list"
                        :disabled="questionTranslationGlobalDisabled"
                        @change="onFilterChange"
                        />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4" offset-md="2" class="text-right pr-0">
                <b-form-input
                    class="mb-3"
                    placeholder="제목, 질문코드 입력 후 엔터를 쳐주세요"
                    v-model="search_question"
                    @keyup.enter="searchByQuestionName"
                    :disabled="questionTranslationGlobalDisabled"
                    />
                <b-btn
                    class="mr-2"
                    variant="info"
                    @click="initializeQuestionAllTranslation"
                    :disabled="questionTranslationGlobalDisabled"
                    >
                    번역 일괄 초기화

                    <span v-show="total_initialize_progress !== false">
                        ({{ total_initialize_progress }} %)
                    </span>
                </b-btn>
                <b-btn
                    v-if="total_initialize_progress !== false"
                    class="mr-2"
                    variant="danger"
                    :disabled="is_cancel_bulk_initialize"
                    @click="is_cancel_bulk_initialize = true"
                    >
                    중단
                </b-btn>
                <b-btn
                    @click="is_collapsed_full_list = !is_collapsed_full_list"
                    :disabled="questionTranslationGlobalDisabled"
                    >
                    전체 {{ is_collapsed_full_list ? '펼쳐보기' : '접기' }}
                </b-btn>
            </b-col>
        </b-row>
        <b-row v-if="load_error" class="mx-5 mb-3">
            <b-col cols="12">
                <PageEmptyComponent :error="load_error" @retry="retryReadTemplate" />
            </b-col>
        </b-row>
        <b-row v-show="is_loading_template" class="py-5 mx-5 mb-3 bgray-300">
            <b-col cols="12" class="h-100">
                <div class="d-flex align-items-center justify-content-center h-100">
                    <span class="h5 mr-3 mb-0">
                        {{ question_info_progress ? `질문 정보 불러오는 중 (${question_info_progress.done}/${question_info_progress.total})` : '불러오는중' }}
                    </span>
                    <b-spinner style="width: 2rem;height: 2rem;" />
                </div>
            </b-col>
        </b-row>
        <b-row v-if="!is_loading_template && failed_question_codes.length" class="mx-5 mb-3">
            <b-col cols="12">
                <b-alert show variant="warning" class="d-flex align-items-center justify-content-between mb-0">
                    <span>
                        불러오지 못한 질문 {{ failed_question_codes.length }}개:
                        {{ failed_question_codes.slice(0, 10).join(', ') }}{{ failed_question_codes.length > 10 ? ' 외' : '' }}
                        — 이 질문들은 번역 칸이 잠겨 있습니다.
                    </span>
                    <b-btn size="sm" variant="warning" :disabled="questionTranslationGlobalDisabled" @click="retryReadTemplate">
                        다시 불러오기
                    </b-btn>
                </b-alert>
            </b-col>
        </b-row>
        <b-row v-show="!is_loading_template" class="mb-3 mx-5">
            <b-col cols="12">
                <div v-if="template_contents && !visibleRowCount" class="text-center bgray-200 rounded py-5">
                    <p class="mb-2">조건에 맞는 질문이 없습니다. 번역이 모두 끝난 질문은 상태 필터에서 숨겨집니다.</p>
                    <b-btn v-if="is_search_question" size="sm" @click="clearSearch">검색어 지우기</b-btn>
                </div>
                <question-translation-row
                    v-for="(template, template_idx) in template_contents"
                    :key="`question-${template.question_code}-question-translation-group-${template_idx}`"
                    v-show="rowVisibility[template_idx]"
                    :template="template"
                    :template-idx="template_idx"
                    :immutable="template_contents_immutable[template_idx]"
                    :disabled="questionTranslationGlobalDisabled"
                    @initialize="initalizeQuestionTranslation"
                    @save="saveEditedQuestion"
                    @toggle-edit="showEditForm"
                    @toggle-collapse="collapseEditForm"
                    @edit="editQuestionInfo"
                    />
            </b-col>
        </b-row>
        <b-row class="mx-5">
            <b-col cols="12" class="text-right pr-0">
                <b-btn
                    class="mr-2"
                    variant="info"
                    @click="initializeQuestionAllTranslation"
                    :disabled="questionTranslationGlobalDisabled"
                    size="sm"
                    >
                    번역 일괄 초기화

                    <span v-show="total_initialize_progress !== false">
                        ({{ total_initialize_progress }} %)
                    </span>
                </b-btn>
                <b-btn
                    @click="is_collapsed_full_list = !is_collapsed_full_list"
                    :disabled="questionTranslationGlobalDisabled"
                    size="sm"
                    >
                    전체 {{ is_collapsed_full_list ? '펼쳐보기' : '접기' }}
                </b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash';
import FuzzySearch from 'fuzzy-search';

import QuestionTranslationRow from '@shared/components/admin/pages/_EditingTemplateTranslation/QuestionTranslationRow.vue';
import PageEmptyComponent from '@shared/components/admin/components/common/PageEmptyComponent.vue';
import unsavedChangesGuard from '@shared/mixin/unsaved-changes-guard';
import { getErrorMessage } from '@core/utils/api/errorMessage';

// URL 의 need 값 ↔ 번역상태 필터 값. 4개 전부면 키를 생략하고, 하나도 안 고르면 need=none.
const NEED_QUERY = {
    name_kr: 'need_name_kr',
    name_tr: 'need_name_translation',
    info_kr: 'need_infobox_kr',
    info_tr: 'need_infobox_translation'
}
const ALL_NEEDS = Object.values(NEED_QUERY)
const QUERY_KEYS = ['need', 'search']
const queryKey = (query) => JSON.stringify(QUERY_KEYS.map(k => [].concat(query[k] == null ? [] : query[k]).map(String).sort()))
// /read_question 동시 요청 수 — 큰 질문지에서 수백 건을 한꺼번에 보내지 않는다
const QUESTION_INFO_CHUNK = 6

export default {
    name: 'editing-template-translation',
    mixins: [unsavedChangesGuard],
    components: { QuestionTranslationRow, PageEmptyComponent },
    data () {
        return {
            is_loading_template: true,
            load_error: '',
            is_cancel_bulk_initialize: false,
            is_saving_template: false,
            template_name: null,
            template_contents: null,
            template_contents_immutable: null,
            template_code: null,
            template_scoring: null,
            template_type: null,
            question_codes: null,
            conditionalView_selected: [
                'need_name_kr',
                'need_infobox_kr',
                'need_name_translation',
                'need_infobox_translation'
            ],
            conditionalViewOption: [
                { text: '제목 미입력', value: 'need_name_kr'},
                { text: '제목 번역 미입력', value: 'need_name_translation'},
                { text: '배경정보 미입력', value: 'need_infobox_kr'},
                { text: '배경정보 번역 미입력', value: 'need_infobox_translation'},
            ],
            is_collapsed_full_list: true,
            search_question: null,
            // Enter 로 실제 적용한 검색어 — URL search 에 올리는 값(입력 중인 값과 다를 수 있다)
            searched_keyword: null,
            is_search_question: false,
            total_initialize_progress: false,
            question_info_progress: null,
            failed_question_codes: []
        }
    },
    computed: {
        ...mapState(['user_id', 'company_id']),
        questionTranslationGlobalDisabled () {
            return  this.is_loading_template || this.is_saving_template || this.total_initialize_progress !== false || !!this.load_error
        },
        hasUnsavedChanges () {
            return !!this.template_contents && this.template_contents.some(_template => _template.edited)
        },
        // 행별 표시 여부를 미리 계산해 둔다.
        // 템플릿 바인딩에서 showQuestionbarBySelectedState(template) 를 직접 호출하면
        // 렌더마다 모든 행에 대해 배열 생성 + some/includes 순회가 재실행된다.
        // 입력 한 글자마다 이 비용이 행 수만큼 반복돼 타이핑이 지연됐다.
        // 방금 저장한 행(kept)은 필터·검색과 무관하게 그 자리에 남긴다(조건을 바꾸면 풀린다).
        // 검색 중이면 검색 결과만 본다 — 번역이 끝난 질문도 검색으로는 찾을 수 있어야 한다.
        // 불러오지 못한 질문은 번역 상태를 모르므로 필터로 숨기지 않는다.
        rowVisibility () {
            if (!this.template_contents) return []

            return this.template_contents.map(_template => {
                if (_template.kept) return true
                if (this.is_search_question) return _template.searched === true
                return !!_template.load_failed || this.showQuestionbarBySelectedState(_template)
            })
        },
        visibleRowCount () {
            return this.rowVisibility.filter(Boolean).length
        }
    },
    watch: {
        is_collapsed_full_list (_collapsed_status) {
            this.template_contents.forEach(content => {
                content.collapsed = _collapsed_status
            });
        },
        // 뒤로가기·링크로 같은 화면의 query 만 바뀐 경우 폼을 따라가게 한다(폼 → URL 은 syncQuery)
        '$route.query' (query) {
            if (queryKey(this.buildQuery()) === queryKey(query)) return
            this.applyQuery(query)
            if (this.template_contents) this.runSearch()
        }
    },
    async created () {
        this.applyQuery(this.$route.query)
        await this.readTemplate()
        if (this.template_contents && this.searched_keyword) this.runSearch()
    },
    methods: {
        async readTemplate () {
            try {
                this.is_loading_template = true
                this.load_error = ''
                const response = await this.$axios.get('/read_template', {
                    params: { template_code: this.$route.params.template_code }
                })

                let _template_contents = JSON.parse(response.data.template_contents)
                _template_contents = this.flattenTemplateContents([ ..._template_contents ])
        
                const _question_codes = _template_contents.map(({ question_code }) => question_code)
                const { infos: _questionsInfo, failed: _failed_codes } = await this.readQuestionsInfo(_question_codes)
                _template_contents = this.mergeTemplateWithTranslation(_template_contents, _questionsInfo, _failed_codes)
                const _template_contents_immutable = JSON.stringify([ ..._template_contents ])
                this.template_contents_immutable = Object.freeze(JSON.parse(_template_contents_immutable))
                this.template_contents = _template_contents
                this.question_codes = _question_codes
                this.failed_question_codes = _failed_codes

                this.template_name = response.data.template_name
                this.template_code = response.data.template_code
                this.template_scoring = response.data.template_scoring
                this.template_type = response.data.template_type
            } catch (error) {
                console.log(` ~ error => `, error);
                if (!(await this.handleUnauthorized(error))) {
                    this.load_error = `질문지를 불러오지 못했습니다. (코드: ${this.$route.params.template_code}, 사유: ${getErrorMessage(error, error && error.message ? error.message : '알 수 없는 오류')})`
                }
            } finally {
                this.question_info_progress = null
                this.$nextTick(() => {
                    this.is_loading_template = false
                })
            }
        },
        async retryReadTemplate () {
            if (this.hasUnsavedChanges) {
                const _ok = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '다시 불러오기',
                    message: '저장하지 않은 번역 변경이 사라집니다. 다시 불러올까요?'
                })
                if (!_ok) return
            }
            await this.readTemplate()
            if (this.template_contents && this.searched_keyword) this.runSearch()
        },
        /** 401 이면 true — 로그인 이동은 axios 인터셉터가 한다(화면은 알림 없이 멈춘다) */
        handleUnauthorized (error) {
            return !!(error && error.response && error.response.status === 401)
        },
        flattenTemplateContents (templates, parent_question_id = null, level = 0) {
            return templates.reduce((_template_codes, _template) => {
                const {
                    question_name, question_name_e, question_name_c,
                    question_infobox, question_infobox_e, question_infobox_c,
                    question_code, children
                } = _template

                _template_codes.push({
                    question_name, question_name_e, question_name_c,
                    question_infobox, question_infobox_e, question_infobox_c,
                    question_code,
                    parent_question_id,
                    level,
                    collapsed: true,
                    edited: false,
                    show_info: true,
                    searched: false,
                    kept: false,
                    load_failed: false
                })
                
                if (children.length) {
                    const _flatten_child_template = this.flattenTemplateContents(children, question_code, level + 1)
                    _template_codes.push(..._flatten_child_template)
                }
                return _template_codes
            }, [])
        },
        // 질문 수만큼의 단건 조회를 QUESTION_INFO_CHUNK 개씩 나눠 보낸다. 한 건이 실패해도 화면 전체를 막지 않고
        // 실패한 코드만 돌려준다(401 은 예외로 던져 readTemplate 이 멈추게 한다).
        async readQuestionsInfo (question_codes) {
            const infos = []
            const failed = []
            this.question_info_progress = { done: 0, total: question_codes.length }
            for (let _start = 0; _start < question_codes.length; _start += QUESTION_INFO_CHUNK) {
                const _chunk = question_codes.slice(_start, _start + QUESTION_INFO_CHUNK)
                const _results = await Promise.allSettled(_chunk.map(_question_code =>
                    this.$axios.get('/read_question', { params: { question_code: _question_code } })
                ))
                _results.forEach((_result, _i) => {
                    if (_result.status === 'fulfilled') {
                        infos.push(this.toQuestionInfo(_result.value.data))
                    } else if (this.handleUnauthorized(_result.reason)) {
                        throw _result.reason
                    } else {
                        console.log(` ~ read_question 실패 (${_chunk[_i]}) => `, _result.reason);
                        failed.push(_chunk[_i])
                    }
                })
                this.question_info_progress.done += _chunk.length
            }
            return { infos, failed }
        },
        toQuestionInfo (data) {
            const { question_name, question_name_e, question_name_c,
                question_infobox, question_infobox_e, question_infobox_c,
                question_code ,template_code
            } = data

            return {
                question_name: this.isValueEmpty(question_name) ? null : question_name,
                question_name_e: this.isValueEmpty(question_name_e) ? null : question_name_e,
                question_name_c: this.isValueEmpty(question_name_c) ? null : question_name_c,
                question_infobox: this.isValueEmpty(question_infobox) ? null : question_infobox,
                question_infobox_e: this.isValueEmpty(question_infobox_e) ? null : question_infobox_e,
                question_infobox_c: this.isValueEmpty(question_infobox_c) ? null : question_infobox_c,
                need_name_kr: this.isValueEmpty(question_name),
                need_infobox_kr: this.isValueEmpty(question_infobox),
                need_name_translation: this.isValueEmpty(question_name_e) || this.isValueEmpty(question_name_c),
                need_infobox_translation: this.isValueEmpty(question_infobox_e) || this.isValueEmpty(question_infobox_c),
                question_code, template_code
            }
        },
        mergeTemplateWithTranslation (templates, templatesInfo, failed_codes = []) {
            return templates.reduce((_templates, _template, _template_idx) => {
                const _question_translaton = templatesInfo.find(({ question_code }) => question_code === _template.question_code)
                if (_question_translaton) {
                    _templates[_template_idx] = { ..._template, ..._question_translaton }
                } else if (failed_codes.includes(_template.question_code)) {
                    // 조회 실패 — 템플릿에 있던 값을 그대로 둔다(번역을 null 로 바꾸면 다른 행을 저장할 때 템플릿에서 지워진다)
                    _templates[_template_idx] = { ..._template, load_failed: true }
                } else {
                    _templates[_template_idx] = {
                        ..._template,
                        question_name_e: null, question_name_c: null,
                        question_infobox_e: null, question_infobox_c: null
                    }
                }
                
                return _templates
            }, templates)
        },
        showEditForm (template_idx) {
            this.template_contents[template_idx].show_info = !this.template_contents[template_idx].show_info
        },
        collapseEditForm (template_idx) {
            this.template_contents[template_idx].collapsed = !this.template_contents[template_idx].collapsed
        },
        // 4개 입력 칸 전부를 원본과 비교한다(마지막으로 만진 칸만 비교하면 다른 칸의 미저장 변경을 놓친다)
        editQuestionInfo (question_idx) {
            this.$nextTick(() => {
                const _current = this.template_contents[question_idx]
                const _origin = this.template_contents_immutable[question_idx]
                if (!_current || !_origin) return
                _current.edited = ['question_name_e', 'question_name_c', 'question_infobox_e', 'question_infobox_c']
                    .some(_field => (_current[_field] || '') !== (_origin[_field] || ''))
            })
        },
        async saveEditedQuestion (question_idx) {
            try {
                this.is_saving_template = true
                const {
                    question_code,
                    question_name_e, question_name_c,
                    question_infobox_e, question_infobox_c
                } = this.template_contents[question_idx]

                // 번역수정 버전 저장
                const formData = new FormData()
                if (!this.isValueEmpty(question_name_e)) formData.append('question_name_e', question_name_e)
                if (!this.isValueEmpty(question_name_c)) formData.append('question_name_c', question_name_c)
                if (!this.isValueEmpty(question_infobox_e)) formData.append('question_infobox_e', question_infobox_e)
                if (!this.isValueEmpty(question_infobox_c)) formData.append('question_infobox_c', question_infobox_c)

                const _res_update_question = await this.$axios.post(`/translate/question/${question_code}`, formData)

                // 번역 수정한 template_contents 업데이트
                this.template_contents[question_idx] = {
                    ...this.template_contents[question_idx],
                    ..._res_update_question.data
                }
                
                // 업데이트 템플릿 컨텐츠
                await this.updateTemplateContents(question_idx)
                this.$EventBus.$emit('toast-success', '성공', `번역을 저장하였습니다. (${question_code})`)
            } catch (error) {
                console.log(` ~ error => `, error);
                if (!(await this.handleUnauthorized(error))) {
                    // 입력한 내용(edited 상태)은 그대로 두고 재시도할 수 있게 한다
                    this.$EventBus.$emit('toast-failure', '번역 저장 실패', getErrorMessage(error, error && error.message ? error.message : '저장하지 못했습니다. 다시 시도해주세요.'))
                }
            } finally {
                this.is_saving_template = false
            }
        },
        async initializeQuestionAllTranslation () {
            const _total = this.template_contents.length
            if (!_total) return

            const _ok = await this.$showModal({
                type: 'confirm',
                state: 'error',
                title: '번역 일괄 초기화',
                message: `질문 ${_total}개의 영문/중문 제목·배경정보가 초기화됩니다(수동으로 교정한 번역과 저장하지 않은 편집 포함). 되돌릴 수 없습니다. 진행 중에는 '중단'으로 멈출 수 있습니다.`
            })
            if (!_ok) return

            this.total_initialize_progress = 0
            this.is_cancel_bulk_initialize = false
            let _done = 0
            const _failed_codes = []
            try {
                for (const [_template_index, _template_content] of this.template_contents.entries()) {
                    if (this.is_cancel_bulk_initialize) break
                    try {
                        await this.requestInitializeQuestion(_template_index, _template_content.question_code)
                    } catch (error) {
                        if (await this.handleUnauthorized(error)) return
                        _failed_codes.push(_template_content.question_code)
                    }
                    _done++
                    this.total_initialize_progress = Math.floor((_done / _total) * 100)
                }

                // 템플릿 저장은 루프가 끝난 뒤 한 번만
                if (_done > _failed_codes.length) {
                    await this.updateTemplateContents(null)
                }

                const _summary = `${_done - _failed_codes.length}개 초기화${_failed_codes.length ? `, ${_failed_codes.length}개 실패(${_failed_codes.slice(0, 5).join(', ')}${_failed_codes.length > 5 ? ' 외' : ''})` : ''}${this.is_cancel_bulk_initialize ? ' (중단됨)' : ''}`
                this.$EventBus.$emit(_failed_codes.length ? 'toast-warning' : 'toast-success', '번역 일괄 초기화', _summary)
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '번역 일괄 초기화 실패', getErrorMessage(error, error && error.message ? error.message : '템플릿을 저장하지 못했습니다.'))
            } finally {
                this.total_initialize_progress = false
                this.is_cancel_bulk_initialize = false
            }
        },
        // 서버 초기화 + 화면 반영만 한다(템플릿 저장은 호출한 쪽에서)
        async requestInitializeQuestion (question_idx, question_code) {
            let _initial_target_formData = new FormData()
            _initial_target_formData.append('question_name', null)
            _initial_target_formData.append('question_infobox', null)

            const _res_initialized_question = await this.$axios.post(`/translate/initial/question/${question_code}`, _initial_target_formData)
            const _initialized_question = _res_initialized_question.data

            this.template_contents[question_idx].question_name_e = _initialized_question.question_name_e
            this.template_contents[question_idx].question_name_c = _initialized_question.question_name_c
            this.template_contents[question_idx].question_infobox_e = _initialized_question.question_infobox_e
            this.template_contents[question_idx].question_infobox_c = _initialized_question.question_infobox_c
        },
        async initalizeQuestionTranslation (question_idx, question_code) {
            try {
                this.is_saving_template = true
                await this.requestInitializeQuestion(question_idx, question_code)

                // 업데이트 템플릿 컨텐츠
                await this.updateTemplateContents(question_idx)
                this.$EventBus.$emit('toast-success', '성공', `번역을 초기화하였습니다. (${question_code})`)
            } catch (error) {
                console.log(` ~ error => `, error);
                if (!(await this.handleUnauthorized(error))) {
                    this.$EventBus.$emit('toast-failure', '번역 초기화 실패', getErrorMessage(error, error && error.message ? error.message : '초기화하지 못했습니다. 다시 시도해주세요.'))
                }
            } finally {
                this.is_saving_template = false
            }
        },
        async updateTemplateContents (question_idx) {
            // template의 template_contents 업데이트 하기 위한 평면화된 template_contents를 계층화 구조로 변환
            // 한 행 저장이면 그 행만 지금 값, 나머지 행은 마지막 저장값으로 보낸다
            // (다른 행에서 저장하지 않은 편집이 질문 API 는 거치지 않고 템플릿에만 섞여 저장되지 않게)
            const _source = question_idx === null
                ? this.template_contents
                : this.template_contents.map((_row, _idx) => _idx === question_idx ? _row : (this.template_contents_immutable[_idx] || _row))
            const _nested_data_contents = this.generateNestedTemplateContents(_source)

            // 업데이트된 계층 구조의 template_contents 저장
            const _formData = new FormData()
            _formData.append('user_id', this.user_id)
            _formData.append('template_name', this.template_name)
            _formData.append('template_code', this.template_code)
            _formData.append('template_scoring', this.template_scoring)
            _formData.append('template_type', this.template_type)
            _formData.append('template_contents', JSON.stringify(_nested_data_contents))

            const _res_updated_template = await this.$axios.post('/save_template', _formData)

            // db에 저장된 data로 관련 state 갱신
            this.template_code = _res_updated_template.data.template_code
            this.template_scoring = _res_updated_template.data.template_scoring
            this.template_type = _res_updated_template.data.template_type

            // 저장된 template_contents 평면화 구조로 전환 및 question_codes 업데이트
            const _updated_template_contents = JSON.parse(_res_updated_template.data.template_contents)
            let _updated_flatten_template = this.flattenTemplateContents(_updated_template_contents)
            _updated_flatten_template = _updated_flatten_template.map(_template => ({
                ..._template,
                need_name_kr: this.isValueEmpty(_template.question_name),
                need_infobox_kr: this.isValueEmpty(_template.question_infobox),
                need_name_translation: this.isValueEmpty(_template.question_name_e) || this.isValueEmpty(_template.question_name_c),
                need_infobox_translation: this.isValueEmpty(_template.question_infobox_e) || this.isValueEmpty(_template.question_infobox_c),
            }))

            // 행 표시 상태(검색 결과·펼침·편집 폼·불러오기 실패)는 저장과 무관하므로 그대로 옮긴다
            const _carry = (_fresh, _prev) => _prev
                ? { ..._fresh, searched: _prev.searched, collapsed: _prev.collapsed, show_info: _prev.show_info, load_failed: _prev.load_failed }
                : _fresh

            this.question_codes = _updated_flatten_template.map(({ question_code }) => question_code)
            if (question_idx === null) {
                const _template_contents_immutable = JSON.stringify([ ..._updated_flatten_template ])
                this.template_contents_immutable = Object.freeze(JSON.parse(_template_contents_immutable))
                this.template_contents = _updated_flatten_template.map((_fresh, _idx) => _carry(_fresh, this.template_contents[_idx]))
            } else {
                // 기준값도 저장한 행만 바꾼다 — 다른 행의 저장 안 한 편집(edited) 판정이 그대로 남게
                this.template_contents_immutable = Object.freeze(this.template_contents_immutable.map((_origin, _idx) =>
                    _idx === question_idx ? JSON.parse(JSON.stringify(_updated_flatten_template[_idx])) : _origin
                ))
                // 방금 저장한 행은 번역이 끝나 필터 조건에서 빠져도 그 자리에 남긴다(kept — 필터·검색을 바꾸면 풀린다)
                this.$set(this.template_contents, question_idx, {
                    ..._carry(_updated_flatten_template[question_idx], this.template_contents[question_idx]),
                    kept: true
                })
            }
        },
        generateNestedTemplateContents (templateContents, _question_code = null) {
            const filtered = templateContents.filter(item => {
                return item.parent_question_id === _question_code
            })

            const filteredMap = filtered.map(_child => {
                const {
                    question_name, question_name_e, question_name_c,
                    question_infobox, question_infobox_e, question_infobox_c,
                    question_code
                } = _child

                const _nested_parent = {
                    question_name: this.isValueEmpty(question_name) ? null : question_name,
                    question_name_e: this.isValueEmpty(question_name_e) ? null : question_name_e,
                    question_name_c: this.isValueEmpty(question_name_c) ? null : question_name_c,
                    question_infobox: this.isValueEmpty(question_infobox) ? null : question_infobox,
                    question_infobox_e: this.isValueEmpty(question_infobox_e) ? null : question_infobox_e,
                    question_infobox_c: this.isValueEmpty(question_infobox_c) ? null : question_infobox_c,
                    question_code,
                    children: this.generateNestedTemplateContents(templateContents, question_code)
                }

                return _nested_parent
            });
            
            return filteredMap
        },
        showQuestionbarBySelectedState ({ need_name_kr, need_name_translation, need_infobox_kr, need_infobox_translation }) {
            const _show_status = []
            if (need_name_kr) _show_status.push('need_name_kr')
            if (need_name_translation) _show_status.push('need_name_translation')
            if (need_infobox_kr) _show_status.push('need_infobox_kr')
            if (need_infobox_translation) _show_status.push('need_infobox_translation')

            if (!_show_status.length) {
                return false
            } else {
                return _show_status.some(_status => this.conditionalView_selected.includes(_status))
            }
        },
        // Enter — 입력한 검색어를 적용하고 URL 에 남긴다
        searchByQuestionName () {
            this.searched_keyword = this.isValueEmpty(this.search_question) ? null : this.search_question.trim()
            this.runSearch()
            this.syncQuery()
        },
        // 사용자가 필터를 바꿀 때만 URL 에 쓴다(URL → 폼 복원은 다시 URL 을 쓰지 않는다)
        onFilterChange (selected) {
            // change 는 v-model(input) 갱신 뒤에 오지만, 순서에 기대지 않게 받은 값으로 맞춘다
            this.conditionalView_selected = selected
            this.releaseKeptRows()
            this.syncQuery()
        },
        clearSearch () {
            this.search_question = null
            this.searchByQuestionName()
        },
        // searched_keyword 로 행을 다시 표시한다. 이전 검색 결과(searched)는 지우고 새 결과만 남긴다.
        runSearch () {
            if (!this.template_contents) return
            this.releaseKeptRows()
            this.template_contents.forEach(element => {
                element.searched = false
            })
            if (!this.searched_keyword) {
                this.is_search_question = false
                return
            }
            const searcher = new FuzzySearch(this.template_contents,
                ['question_code', 'question_name', 'question_infobox', 'question_name_e', 'question_infobox_e', 'question_name_c', 'question_infobox_c'],
                { caseSensitive: true }
            );

            searcher.search(this.searched_keyword).forEach(element => {
                element.searched = true
            });
            this.is_search_question = true
        },
        releaseKeptRows () {
            (this.template_contents || []).forEach(_template => {
                if (_template.kept) _template.kept = false
            })
        },
        // URL ← 폼. 필터 체크와 Enter 검색은 이력을 쌓지 않게 replace 한다.
        buildQuery () {
            const _selected = ALL_NEEDS.filter(_value => this.conditionalView_selected.includes(_value))
            const query = { ...this.$route.query }
            delete query.need
            delete query.search
            if (!_selected.length) query.need = 'none'
            else if (_selected.length < ALL_NEEDS.length) query.need = Object.keys(NEED_QUERY).filter(_key => _selected.includes(NEED_QUERY[_key]))
            if (this.searched_keyword) query.search = this.searched_keyword
            return query
        },
        syncQuery () {
            const query = this.buildQuery()
            if (queryKey(query) === queryKey(this.$route.query)) return
            this.$router.replace({ query }).catch(() => {})
        },
        // URL → 폼. 범위 밖 값은 무시한다.
        applyQuery (query) {
            const _need = [].concat(query.need == null ? [] : query.need)
            const _selected = _need.map(_key => NEED_QUERY[_key]).filter(Boolean)
            this.conditionalView_selected = _need.includes('none')
                ? []
                : _selected.length ? ALL_NEEDS.filter(_value => _selected.includes(_value)) : ALL_NEEDS.slice()
            const _search = typeof query.search === 'string' && query.search.trim() ? query.search.trim() : null
            this.searched_keyword = _search
            this.search_question = _search
        },
        titleMarginClasses (nestedLevel) {
            return [ 'node-level', `node-level-${nestedLevel}`, 'rounded' ]
        },
        isValueEmpty (val) {
            return !val || val.trim() === ''
        }
    }
}
</script>

<style lang="scss" scoped>

// 행 내부 스타일(-title / -body / -level-* 등)은 QuestionTranslationRow.vue 로 옮겼다.
// scoped 스타일은 자식 컴포넌트의 **루트 요소**에만 부모 scope id 가 붙으므로,
// 여기 남겨두면 자식 내부 요소에는 적용되지 않는다.
// 아래 형제 마진은 행끼리의 관계라 부모가 소유한다 (루트에는 적용됨).
.questionBar {
    & + .questionBar {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
}

</style>
